module.exports = __webpack_public_path__ + "static/media/l.43d2715c.svg";